export const SEARCH_QUERY_PARAMS = {
  Quarter: 'quarter',
  Year: 'year',
  StartQuarter: 'startQuarter',
  StartYear: 'startYear',
  EndQuarter: 'endQuarter',
  EndYear: 'endYear',
  Insurer: 'insurers',
  CoverageCode: 'coverageCodes',
  County: 'counties',
  GroupBy: 'groupBy',
};
